import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import toast from "react-hot-toast";
import "./Manage.css";
import {
    getBuildItem,
} from "../../Helpers/apiCalls/Manage/BuildItem";
import InputError from "../../Components/InputError/InputError";
import NoDataImg from "../../Assets/Images/no-data-img.png";
import { changeStatus, getJobOrder } from "../../Helpers/apiCalls/Manage/JobOrder";
import { dateFormat, getType, numberFormat, refreshPage, toastStyle } from "../../Helpers/Utils/Common";
import ApproveModal from "../../Components/Modals/ApproveModal";
import cleanLogo from "../../Assets/Images/Login/transparent_bg.png";
import moment from "moment";
import Modal from "antd/es/modal/Modal";
import FileExceedModal from "../../Components/Modals/FileExceedModal";
import noDataImg from "../../Assets/Images/no-data-img.png";
import Footer from "../../Components/Footer/Footer";

/*
    -- VIEW BUILT ITEM
*/
export default function BuildItemView() {
    const { id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();
    const [isClicked, setIsClicked] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showDisapproveModal, setShowDisapproveModal] = useState(false);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [previewFile, setPreviewFile] = useState(null);
    const [preview, setPreview] = useState(false);
    // BUILT ITEM INFO VARIABLES
    const [build, setBuild] = useState({
        branch: "1",
        item: "",
        branchTo: "",
        qty: "",
        unitId: "",
        production_date: "",
        expiration_date: "",
        batch: "",
        production_slip_no: "",
        yield: "",
    });
    const [isSet, setIsSet] = useState(false);

    // Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    const [inactive, setInactive] = useState(true);

    async function fetchBuildItem() {
        setBuild([]);
        const response = await getJobOrder({job_order_id: id});

        if (response.data) {
            setBuild(response.data.data[0]);
            setPrevAttachments(response.data.data[0].attachments)
            setIsSet(true);
        }
    }

    function renderTableMaterialsRequired(type) {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Qty</th>
                        <th>Used Qty</th>
                        <th>Unit</th>
                    </tr>
                </thead>
                <tbody>
                    {isSet
                        ? build.items?.map(
                              (product, index) => {
                                  return (
                                      <tr>
                                          <td>
                                              <Form.Control
                                                  type="text"
                                                  name="item_name"
                                                  value={product.item_name}
                                                  disabled
                                              />
                                          </td>
                                          <td>
                                              <Form.Control
                                                  type="text"
                                                  name="qty"
                                                  min="0"
                                                  value={numberFormat(product.qty)}
                                                  disabled
                                              />
                                          </td>
                                          <td>
                                              <Form.Control
                                                  type="text"
                                                  name="qty_used"
                                                  min="0"
                                                  value={numberFormat(product.qty_used)}
                                                  disabled
                                              />
                                          </td>
                                          <td>
                                              <Form.Control
                                                  type="text"
                                                  name="unit"
                                                  value={product.unit}
                                                  disabled
                                              />
                                          </td>
                                      </tr>
                                  );
                              }
                          )
                        : ""}
                </tbody>
            </Table>
        );
    }

    function renderPrintTable(type) {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Qty</th>
                        <th>Used Qty</th>
                        <th>Unit</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        build.items?.map(
                              (item) => {
                                  return (
                                    <tr>
                                        <td className="franchise-td-gray">{item.item_name}</td>
                                        <td className="franchise-td-gray">{numberFormat(item.qty)}</td>
                                        <td className="franchise-td-gray">{numberFormat(item.qty_used)}</td>
                                        <td className="franchise-td-gray">{item.unit}</td>
                                    </tr>
                                  )
                              })
                    }
                </tbody>
            </Table>
        );
    }

    async function handlePrintPI() {
        toast.loading("Printing Transfer Details", { style: toastStyle() });
        setShowPrintModal(false);
        setTimeout(() => {
        toast.dismiss();
        Print();
        }, 1000);
    }

    function Print() {
        let printContents = document.getElementById("printablediv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print(printContents);
        document.body.innerHTML = originalContents;
        refreshPage();
    }
    
    async function handleChangeStatus(status) {
        setIsClicked(true);
        const response = await changeStatus(id, status);
        if (response.data) {
            toast.success(response.data.message, {style: toastStyle()});
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            setTimeout(() => {
                navigate("/builditem")
            }, 1000);
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            setTimeout(() => {
                navigate("/builditem")
            }, 1000);
        }
        setIsClicked(false);
    }

    useEffect(() => {
        fetchBuildItem();
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"INVENTORY"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BUILD ITEM </h1>
                    </Col>
                </Row>

                
                <div className="mt-3 edit-form">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>Branch From</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="branch_from_name"
                                value={build.branch_from_name}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Requested By</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="requested_by_name"
                                value={build.requested_by_name}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Issued</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="job_order_date"
                                value={dateFormat(build.job_order_date)}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                            <InputError
                                isValid={isError.job_order_date}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>ORDER DETAILS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Type</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="type"
                                value={build.type}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Item</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="build_item_name"
                                value={build.build_item_name}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Quantity</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="build_item_qty"
                                value={build.build_item_qty}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Branch To</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="branch_to_name"
                                value={build.branch_to_name}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Description of Work</Col>
                        <Col sm={4}>
                            <textarea
                                type="text"
                                name="description"
                                value={build.description}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                            <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Estimated Time</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="estimated_time"
                                value={build.estimated_time}
                                className="nc-modal-custom-input"
                                disabled
                                required
                            />
                            <InputError
                                isValid={isError.estimated_time}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>Materials Required</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>
                        <div className="edit-purchased-items">
                            {build?.materials_required?.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsRequired()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                        </Col>
                    </Row>
                   {/* <Row className="nc-modal-custom-row">
                        <Col>Materials Used</Col>
                    </Row>
                     <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {build?.materials_used?.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsUsed()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row> */}
                    {
                        build.status === "completed" && (
                            <>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Date Completed</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="date"
                                        name="date_completed"
                                        value={build.date_completed}
                                        className="nc-modal-custom-input"
                                        disabled
                                        required
                                    />
                                    <InputError
                                        isValid={isError.date_completed}
                                        message={"Date is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Time In</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="datetime-local"
                                        name="time_in"
                                        defaultValue={build.time_in}
                                        className="react-select-container"
                                        disabled
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Time out</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="datetime-local"
                                        name="time_end"
                                        defaultValue={build.time_end}
                                        className="react-select-container"
                                        disabled
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Acknowledged By</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="text"
                                        name="acknowledge_by_name"
                                        value={build.acknowledge_by_name}
                                        className="nc-modal-custom-input"
                                        disabled
                                        required
                                    />
                                </Col>
                            </Row>
                            {
                                accountType === "admin" && (
                                    <>
                                        <Row className="nc-modal-custom-row">
                                            <Col>Complete Information (For Admin Only)</Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Job Order No.</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="text"
                                                    name="job_order_no"
                                                    value={build.job_order_no}
                                                    className="nc-modal-custom-input"
                                                    disabled
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.job_order_no}
                                                    message={"Job Order No. is required"}
                                                />
                                            </Col>
                                            <Col sm={3}>Schedule Date</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="datetime-local"
                                                    name="schedule_date"
                                                    value={build.schedule_date}
                                                    className="nc-modal-custom-input"
                                                    disabled
                                                />
                                                <InputError
                                                    isValid={isError.schedule_date}
                                                    message={"Job order no. is required"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Job Requesting To</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="text"
                                                    name="job_requesting_to"
                                                    value={build.job_requesting_to}
                                                    className="nc-modal-custom-input"
                                                    disabled
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.job_requesting_to}
                                                    message={"Job requesting to is required"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Remarks</Col>
                                            <Col >
                                                <textarea
                                                    type="text"
                                                    name="remarks"
                                                    value={build.remarks}
                                                    className="nc-modal-custom-input"
                                                    disabled
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.remarks}
                                                    message={"Remarks is required"}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )
                            }
                            </>
                        )
                    }
                    <div className="mt-4 noPrint mx-3">
                        <Row className="review-data mb-2">
                            FILE ATTACHMENTS
                        </Row>
                        <Row className="">
                            {
                                prevAttachments && prevAttachments.map((attachment) => (
                                    <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                        <img src={attachment.file_url}  className="img-preview"/>
                                    </Col>
                                ))
                            }
                            {
                                !prevAttachments || prevAttachments.length === 0 && 
                                <Col xs={1}>
                                <div className="no-data-cont d-flex justify-content-left preview-container">
                                    <img src={noDataImg} alt="no data found" className="img-preview"/>
                                </div>
                                </Col>
                            }
                        </Row>
                    </div>
                </div>
                <div className="d-flex justify-content-end pt-2 pb-3">
                    <button
                        type="button"
                        className="button-tertiary me-1"
                        onClick={() => setShowPrintModal(true)}
                    >
                        Print
                    </button>
                    {
                        build.status === "pending" && (
                        <>
                        <button
                            type="button"
                            className="button-primary me-1"
                            onClick={() => setShowDisapproveModal(true)}
                        >
                            Reject
                        </button>
                        <button
                            type="button"
                            className="button-tertiary me-1"
                            onClick={() => setShowApproveModal(true)}
                        >
                            Approve
                        </button>
                        </>
                        )
                    }
                    <button
                        type="button"
                        className="button-secondary"
                        onClick={() => navigate("/builditem")}
                    >
                        Back
                    </button>
                </div>
            </div>
            <ApproveModal
                show={showApproveModal}
                hide={() => setShowApproveModal(false)}
                type="approve"
                text="approve this job order"
                handler={() => handleChangeStatus("approved")}
                isClicked={isClicked}
            />
            <ApproveModal
                show={showPrintModal}
                hide={() => setShowPrintModal(false)}
                type="Print"
                text="Print this Job Order"
                handler={() => handlePrintPI()}
                isClicked={isClicked}
            />
            <ApproveModal
                show={showDisapproveModal}
                hide={() => setShowDisapproveModal(false)}
                type="disapprove"
                text="disapprove this job order"
                handler={() => handleChangeStatus("rejected")}
                isClicked={isClicked}
            />

            {/* PRINT VIEW */}
            <div className="print-container px-3 py-2 display-none" id="printablediv">
                <div className="text-end print-header d-flex flex-column">
                {/* <span>TRANSFER NO. {build.transfer_number}</span> */}
                <span className="text-uppercase">
                    {moment().format("MMMM DD, yyyy")}
                </span>
                </div>
                <div className="d-flex justify-content-center py-1">
                <div className="d-flex justify-content-center py-1">
                    <img src={cleanLogo} className="print-logo" alt=""/>
                </div>
                <div className="print-top">
                    <h5 className="print-shop-header d-flex justify-content-center">LEYTE PAPERWORLD</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">168 M.H. Del Pilar, Tacloban City, Leyte</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">(053) 325-3888 (053) 325-7088</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">penpaperworld@yahoo.com</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">SE PURCHASE INVOICE</h5>
                </div>
                </div>
                    <div className="print-body mt-5">
                        <Container fluid>
                            <Row className="review-container py-3">
                                <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Branch:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.branch_from_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Requested By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.requested_by_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Requesting To:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.branch_to_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Date Issued:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.job_order_date}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Type:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.type}
                                    </Col>
                                </div>
                                </Col>
                                <Col>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Build Item:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.build_item_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Build Quantity:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.build_item_qty}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Description:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.description}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                    Estimated Time:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                    {build.estimated_time}
                                    </Col>
                                </div>
                                </Col>
                            </Row>
                        </Container>

                        {
                            build.status === "completed" && (
                                <>
                                <Container fluid className="mt-4">
                                    <Row className="review-container py-3">
                                        <Col>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Date Completed:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.date_completed}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Time In:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.time_in}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Time Out:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.time_end}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Acknowledged By:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.acknowledge_by}
                                            </Col>
                                        </div>
                                        </Col>
                                        <Col>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Job Order No.:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.job_order_no}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Job Requesting To:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.job_requesting_to}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Schedule Date:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.schedule_date}
                                            </Col>
                                        </div>
                                        <div className="d-flex my-2 align-items-center">
                                            <Col xs={4} className="print-label">
                                            Remarks:
                                            </Col>
                                            <Col xs={7} className="print-data">
                                            {build.remarks}
                                            </Col>
                                        </div>
                                        </Col>
                                    </Row>
                                </Container>
                                </>
                            )
                        }
                        <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            Materials Required
                        </span>
                        <div className="print-table">{renderPrintTable()}</div>
                        </div>
                        <div className="print-signatures">
                        <span className="text-center text-uppercase print-label">
                            {build.approved_by_name}
                        </span>
                        <span className="text-center text-uppercase print-label fw-bold">
                            {build.added_by_name}
                        </span>
                        </div>
                        <div className="print-signatories pb-4 mb-4">
                        <span>Approved by</span>
                        <span>Prepared by</span>
                        </div>
                    </div>
            </div>
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                </Row>
            </Modal>
            <Footer/>
        </div>
    );
}
